<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <p
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo"
          >
            Relatório de Movimentações de Status Manual
            <Modal
              :tipoSelecao="'ferramentaria'"
              :desativarDevolucao="true"
              :desativarRetirada="true"
              :desativarSolicitante="true"
              :desativarFornecedor="true"
              :desativarNumero="true"
              :desativarDocumentoEntrada="true"
              :desativarDocumentoSaida="true"
              :desativarNtransferencia="true"
              :desativarOrigem="true"
              @unidade="getAtivos"
              :desativarFornecedorSelect="true"
              :desativarTipoMovimento="true"
              :desativarTempo="true"
              :desativarCentro="true"
              :desativarStatus="true"
              :loadingValue="loadingValue"
              :dataDisable="true"
              :classUnidade="'col-6'"
              :classCodigo="'col-5'"
              :classDescricao="'col-6'"
              :classGrupo="'col-6'"
              :classSubgrupo="'col-5'"
              :classPatrimonio="'col-5'"
              :classOrigem="'col-5'"
              :classDocumentoEntrada="'col-6'"
              :classDocumentoSaida="'col-5'"
              :classDataSaida="'col-5'"
              :classDataEntrada="'col-6'"
              :classTransferencia="'col-6'"
            />
          </p>
        </div>
      </div>
    </div>
    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :exportName="'Movimentações_de_Status_Manual'"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      :salvarType="'ferramentaria-relatorio-status-manual'"
      @flexmonsterLoading="loadingStop"
      @enviarRespostaEp="getRelatorioSalvo"
    />
    <q-dialog v-model="showComentarioMovimentacao">
      <q-card style="height: 220px; width: 450px">
        <q-card-section class="column">
          <span style="color: #21324a" class="mensagem-text">Aviso</span>
          <q-separator style="height: 1px; background-color: #21324a" />
        </q-card-section>

        <q-card-section style="min-height: 70px">
          <span style="color: #21324a">
            Seu relatório excedeu o tempo para geração automático, aguarde o
            link na central de notificações pra download do relatório
            completo.</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            label="Confirmar"
            :disabled="desabilitarConfirme"
            no-caps
            icon="done"
            v-close-popup
            style="
              background-color: #21324a;
              border-radius: 8px;
              color: white;
              font-weight: normal;
            "
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Modal from "../components/ModalFerramentaria.vue";
import Flexmonster from "../../relatorios/components/Flexmonster.vue";

export default {
  components: { Flexmonster, Modal },
  setup() {
    const store = useStore();
    const route = useRoute();

    const slice = ref({
      columns: [
        { uniqueName: "Numero Transferencia" },
        { uniqueName: "Status Transferencia" },
        { uniqueName: "Origem Saida" },
        { uniqueName: "Origem Saida Nome" },
        { uniqueName: "Codigo Ativo Inicial" },
        { uniqueName: "Descrição Ativo Inicial" },
        { uniqueName: "Grupo Ativo Inicial" },
        { uniqueName: "Subgrupo Ativo Inicial" },
        { uniqueName: "Patrimonio Ativo Inicial" },
        { uniqueName: "Origem Ativo Inicial" },
        { uniqueName: "Nome Fornecedor Ativo Inicial" },
        { uniqueName: "CNPJ Fornecedor Ativo Inicial" },
        { uniqueName: "Valor Equipamento Ativo Inicial" },
        { uniqueName: "Valor Locacao Ativo Inicial" },
        { uniqueName: "Status Ativo Inicial" },
        { uniqueName: "Documento Tipo Saida" },
        { uniqueName: "Nº Documento Saida" },
        { uniqueName: "Serie Documento Saida" },
        { uniqueName: "Data Emissão Documento Saida" },
        { uniqueName: "Hora Emissão Documento Saida" },
        { uniqueName: "Data Saida" },
        { uniqueName: "Hora Saida" },
        { uniqueName: "Pedido Saida" },
        { uniqueName: "Solicitação Compra Saida" },
        { uniqueName: "Operação Saida" },
        { uniqueName: "Quantidade saida" },
        { uniqueName: "Status Saida" },
        { uniqueName: "Origem Entrada" },
        { uniqueName: "Origem Entrada Nome" },
        { uniqueName: "Codigo Ativo Final" },
        { uniqueName: "Descrição Ativo Final" },
        { uniqueName: "Grupo Ativo Final" },
        { uniqueName: "Subgrupo Ativo Final" },
        { uniqueName: "Patrimonio Ativo Final" },
        { uniqueName: "Origem Ativo Final" },
        { uniqueName: "Nome Fornecedor Ativo Final" },
        { uniqueName: "CNPJ Fornecedor Ativo Final" },
        { uniqueName: "Valor Equipamento Ativo Final" },
        { uniqueName: "Valor Locacao Ativo Final" },
        { uniqueName: "Status Ativo Final" },
        { uniqueName: "Documento Tipo Entrada" },
        { uniqueName: "Nº Documento Entrada" },
        { uniqueName: "Serie Documento Entrada" },
        { uniqueName: "Data Emissão Documento Entrada" },
        { uniqueName: "Hora Emissão Documento Entrada" },
        { uniqueName: "Data Entrada" },
        { uniqueName: "Hora Entrada" },
        { uniqueName: "Pedido Entrada" },
        { uniqueName: "Solicitação Compra Entrada" },
        { uniqueName: "Quantidade Entrada" },
        { uniqueName: "Operação Entrada" },
        { uniqueName: "Status Entrada" },
      ],
      rows: [
        { uniqueName: "Numero Transferencia" },
        { uniqueName: "Status Transferencia" },
        { uniqueName: "Origem Saida" },
        { uniqueName: "Origem Saida Nome" },
        { uniqueName: "Codigo Ativo Inicial" },
        { uniqueName: "Descrição Ativo Inicial" },
        { uniqueName: "Grupo Ativo Inicial" },
        { uniqueName: "Subgrupo Ativo Inicial" },
        { uniqueName: "Patrimonio Ativo Inicial" },
        { uniqueName: "Origem Ativo Inicial" },
        { uniqueName: "Nome Fornecedor Ativo Inicial" },
        { uniqueName: "CNPJ Fornecedor Ativo Inicial" },
        { uniqueName: "Valor Equipamento Ativo Inicial" },
        { uniqueName: "Valor Locacao Ativo Inicial" },
        { uniqueName: "Status Ativo Inicial" },
        { uniqueName: "Documento Tipo Saida" },
        { uniqueName: "Nº Documento Saida" },
        { uniqueName: "Serie Documento Saida" },
        { uniqueName: "Data Emissão Documento Saida" },
        { uniqueName: "Hora Emissão Documento Saida" },
        { uniqueName: "Data Saida" },
        { uniqueName: "Hora Saida" },
        { uniqueName: "Pedido Saida" },
        { uniqueName: "Solicitação Compra Saida" },
        { uniqueName: "Operação Saida" },
        { uniqueName: "Quantidade saida" },
        { uniqueName: "Status Saida" },
        { uniqueName: "Origem Entrada" },
        { uniqueName: "Origem Entrada Nome" },
        { uniqueName: "Codigo Ativo Final" },
        { uniqueName: "Descrição Ativo Final" },
        { uniqueName: "Grupo Ativo Final" },
        { uniqueName: "Subgrupo Ativo Final" },
        { uniqueName: "Patrimonio Ativo Final" },
        { uniqueName: "Origem Ativo Final" },
        { uniqueName: "Nome Fornecedor Ativo Final" },
        { uniqueName: "CNPJ Fornecedor Ativo Final" },
        { uniqueName: "Valor Equipamento Ativo Final" },
        { uniqueName: "Valor Locacao Ativo Final" },
        { uniqueName: "Status Ativo Final" },
        { uniqueName: "Documento Tipo Entrada" },
        { uniqueName: "Nº Documento Entrada" },
        { uniqueName: "Serie Documento Entrada" },
        { uniqueName: "Data Emissão Documento Entrada" },
        { uniqueName: "Hora Emissão Documento Entrada" },
        { uniqueName: "Data Entrada" },
        { uniqueName: "Hora Entrada" },
        { uniqueName: "Pedido Entrada" },
        { uniqueName: "Solicitação Compra Entrada" },
        { uniqueName: "Quantidade Entrada" },
        { uniqueName: "Operação Entrada" },
        { uniqueName: "Status Entrada" },
      ],
      reportFilters: "",
      measures: [
        {
          uniqueName: "Valor Equipamento Ativo Inicial",
          format: "currencyFormat",
        },
        {
          uniqueName: "Valor Equipamento Ativo Final",
          format: "currencyFormat",
        },
        {
          uniqueName: "Valor Locacao Ativo Inicial",
          format: "currencyFormat",
        },
        {
          uniqueName: "Valor Locacao Ativo Final",
          format: "currencyFormat",
        },
      ],
    });
    const link = ref("");
    const id = route.params.id;
    const layout = ref("flat");
    const loadingValue = ref("");
    const showComentarioMovimentacao = ref(false);
    const types = ref({
      Codigo: {
        type: "string",
      },
      "Patrimonio Ativo Inicial": {
        type: "string",
      },
      "Patrimonio Ativo Final": {
        type: "string",
      },
      "Codigo Ativo Inicial": {
        type: "string",
      },
      "Codigo Ativo Final": {
        type: "string",
      },
      "Valor Locacao Ativo Inicial": {
        type: "number",
      },
      "Valor Locacao Ativo Final": {
        type: "number",
      },
      "Nº Documento Saida": {
        type: "string",
      },
      "Nº Documento Entrada": {
        type: "string",
      },
      "Serie Documento Entrada": {
        type: "string",
      },
      "Serie Documento Saida": {
        type: "string",
      },
      "Data Emissão Documento Saida": {
        type: "date string",
      },
      "Data Emissão Documento Entrada": {
        type: "date string",
      },
      "Data Entrada": {
        type: "date string",
      },
      "CNPJ Fornecedor Ativo Final": {
        type: "string",
      },
      "CNPJ Fornecedor Ativo Inicial": {
        type: "string",
      },
      Descricao: {
        type: "string",
      },
      "Matricula Usuario": {
        type: "string",
      },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const showTotals = ref("");
    const filtrosObject = ref(null);
    const showGrandTotals = ref("");
    const formats = ref([
      {
        name: "currencyFormat",
        currencySymbol: "R$ ",
        currencySymbolAlign: "left",
        thousandsSeparator: ".",
        decimalSeparator: ",",
        decimalPlaces: 2,
      },
    ]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});
    const relatorioLink = localStorage.getItem("relatorioLink");

    const getAtivos = async (data, value) => {
      try {
        filtrosObject.value = {
          codigo: value?.codigo,
          unidade: value?.unidade?.id,
          patrimonio: value?.patrimonio,

          grupo: value?.grupo?.catalogoGrupoUuid,
          subgrupo: value?.subGrupo?.catalogoSubGrupoUuid,

          dataInicial: value?.dataSaida?.split("/")?.reverse()?.join("-"),

          dataFinal: value?.dataEntrada?.split("/")?.reverse()?.join("-"),

          descricao: value.descricao != "" ? value.descricao : undefined,
        };

        loadingValue.value = true;
        const response = await store.dispatch(
          "ferramentaria/relatorioStatusManual",
          {
            codigo: value?.codigo == "" ? undefined : value?.codigo,
            unidade: value?.unidade?.id,
            patrimonio: value?.patrimonio == "" ? undefined : value?.patrimonio,

            grupo: value?.grupo?.catalogoGrupoUuid,
            subgrupo: value?.subGrupo?.catalogoSubGrupoUuid,

            dataInicial: value?.dataEntrada?.split("/")?.reverse()?.join("-"),

            dataFinal: value?.dataSaida?.split("/")?.reverse()?.join("-"),

            descricao: value.descricao != "" ? value.descricao : undefined,
          }
        );

        link.value = response.data.resultado.dados;
        updateLink.value++;
        loadingValue.value = false;
        filtros.value = JSON.stringify(filtrosObject.value);
        exibir.value = true;
        url.value = response?.request?.responseURL;
      } catch (error) {
        loadingValue.value = false;
        console.log(error);
      }
    };

    const verificarUrl = async () => {
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        try {
          const response = await store.dispatch("rel/listarRelatoriosSalvos", {
            id,
          });
          let value = response.data.resultado.dados.map((e) => {
            e.template = JSON.parse(e.template);
            return e;
          });
          dados.value = value[0];
          urlEp.value = dados.value.url;
          url.value = dados.value.url;
          gerarCsv.value = true;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (id == "carregado" && store.state.rel.relatorioCarregado != null) {
        dados.value = store.state.rel.relatorioCarregado;
        console.log(dados.value);
        layout.value = dados.value.layout;
        showTotals.value = dados.value.showTotals;
        showGrandTotals.value = dados.value?.showGrandTotals;

        slice.value.columns = dados.value.columns;
        slice.value.rows = dados.value.rows;
        slice.value.reportFilters = dados.value.filtros;
        slice.value.measures = dados.value.values;

        slice.value?.rows.forEach((e) => {
          e.type = "number";
        });

        const response = await store.dispatch("rel/getCarregado", {
          url: dados.value.url.replace(
            /(?<=\/\/)[^.]+/,
            store.state.autenticacao.cliente[0]
          ),
        });

        link.value = response.data.return.url;
        updateLink.value++;
        loadingValue.value = false;
        url.value = response?.request?.responseURL;
        exibir.value = true;

        return;
      }

      if (
        id == "carregadoLink" &&
        relatorioLink != null &&
        relatorioLink != undefined
      ) {
        exibir.value = true;
        link.value = relatorioLink;
        updateLink.value++;
        url.value = relatorioLink;
        return;
      }
    };

    const getRelatorioSalvo = async (response) => {
      loadingValue.value = true;

      filtros.value = dados.value.filtros;
      layout.value = dados.value.template.layout;
      showTotals.value = dados.value.template.showTotals;
      showGrandTotals.value = dados.value.template?.showGrandTotals;
      link.value = response.resultado.dados;

      slice.value.columns = dados.value.template.columns;
      slice.value.rows = dados.value.template.rows;
      slice.value.reportFilters = dados.value.template.filtros;
      slice.value.measures = dados.value.template.values;
      exibir.value = true;

      slice.value?.rows.forEach((e) => {
        e.type = "number";
      });
      loadingValue.value = false;
    };

    const loadingStop = async (value) => {
      loadingValue.value = value;
    };

    onMounted(() => {
      verificarUrl();
    });

    return {
      getAtivos,
      slice,
      layout,
      types,
      link,
      updateLink,
      loadingValue,
      exibir,
      filtros,
      showTotals,
      id,
      getRelatorioSalvo,
      formats,
      loadingStop,
      verificarUrl,
      url,
      showComentarioMovimentacao,
      urlEp,
      gerarCsv,
      dados,
      showGrandTotals,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
